import { SEATERS_TINY_API_KEY } from './env';
export const tinyApiKey = SEATERS_TINY_API_KEY;
